import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client, { apiError } from '../api/client';
import { useAuth } from '../context';

export default function MfaVerify() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const mfaToken = sessionStorage.getItem('pmp_mfa_token');

  useEffect(() => {
    if (!mfaToken) navigate('/login');
  }, [mfaToken, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await client.post('/auth/mfa', { mfaToken, code });
      sessionStorage.removeItem('pmp_mfa_token');
      login(data.token, data.user);
      navigate(data.user.role === 'student' ? '/dashboard' : '/admin');
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-narrow" style={{ marginTop: 48 }}>
      <div className="card card-pad-lg">
        <h1>Two-step verification</h1>
        <p className="muted small">Enter the one-time code we just emailed you.</p>
        <div className="divider" />
        {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label>Verification code</label>
            <input value={code} onChange={(e) => setCode(e.target.value)} maxLength={6}
              inputMode="numeric" placeholder="123456" required autoFocus />
          </div>
          <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Verify and sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
